import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { SharedModule } from '../../modules/shared/shared.module';

import { EventsComponent } from './events.component';
import { EventTableComponent } from './components/event-table/event-table.component';
import { EventTableDetailComponent } from './components/event-table-detail/event-table-detail.component';
import { CreateEventModalComponent } from './components/create-event-modal/create-event-modal.component';
import { EventRequestModalComponent } from './components/event-request-modal/event-request-modal.component';

@NgModule({
  declarations: [
    EventsComponent,
    EventTableComponent,
    EventTableDetailComponent,
    CreateEventModalComponent,
    EventRequestModalComponent
  ],
  imports: [
    CommonModule,
    RouterModule.forChild([
      { path: 'events', component: EventsComponent
      }
    ]),
    NgbModule,
    FormsModule,
    SharedModule
  ]
})
export class EventsModule { }
